import { render, staticRenderFns } from "./enquiry-history-description.vue?vue&type=template&id=7663db4c&"
import script from "./enquiry-history-description.vue?vue&type=script&lang=ts&"
export * from "./enquiry-history-description.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports